<script>
    import { createEventDispatcher } from 'svelte';
    import Spinner from 'svelte-spinner';
    import { Tooltip } from "sveltestrap";

    import { vptServer, token } from '../../stores.js';
    import { dateDescriptionStringAddExtraDescriptor, formatDate } from '../../date-time';
    import { countActiveEarlyDaysElements } from '../../config';

    import EarlyDaysElement from './EarlyDaysElement.svelte';

    const dispatch = createEventDispatcher();

    export let id;
    export let todaysConfig;
    export let selectedInmateAspect;

    let earlyDaysRecord;
    let isInEarlyDaysPeriod;
    let elementCount;

    $: displayCompact = elementCount > 6;
    $: displayComfortable = elementCount < 4;

    $: {
        if (todaysConfig) {
            earlyDaysRecord = null;
            getEarlyDaysRecord();
        }
    }

    async function getEarlyDaysRecord() {
        await fetch(`${$vptServer}/inmate/${id}/earlydays/overview`, {
            headers: {
                "Authorization": "Bearer " + $token
            }
        })
        .then(r => {
            if (!r.ok) {
                throw Error(r.status);
            }
            return r;
        })
        .then(r => r.json())
        .then(data => {
            isInEarlyDaysPeriod = data.indicatorTargeted != null;
            dispatch('dataLoad', { isAspectArchived: !isInEarlyDaysPeriod });
            earlyDaysRecord = data;
            elementCount = countActiveEarlyDaysElements(todaysConfig);
        })
        .catch(error => {
            console.error("Error getting inmate early days overview");
            console.error(error);
            return;
        });
    }
</script>

<style>
    .inmate-widget {
        width: 160px;
    }

    .inmate-widget.comfortable {
        width: 150px;
    }

    .list-widget {
        padding: 0 5px;
    }

    .list-widget-body {
        flex-direction: row;
        flex-wrap: wrap;
        padding: 2px 0 4px 0;
    }

    .list-widget-body.compact {
        padding: 0;
    }
</style>

{#if isInEarlyDaysPeriod != null && isInEarlyDaysPeriod == true}
    <div class="inmate-widget" class:comfortable={displayComfortable}>
        {#if earlyDaysRecord}
            <button class="button-reset focus-outline card" on:click class:selected={selectedInmateAspect === `${todaysConfig.earlyDaysLabelName} Engagement`}>
                <div class="card-body">
                    <div class="widget-container">
                        <span id="early-days-widget-header" class="widget-label" class:widget-label-targeted={earlyDaysRecord.indicatorTargeted}
                                class:widget-label-trend={earlyDaysRecord.indicatorTrend == 'U'}>
                            {#if earlyDaysRecord.indicatorTargeted}
                                <img id="targeted-indicator-early-days" src="/assets/target-indicator.svg" alt="Targeted on the {todaysConfig ? todaysConfig.earlyDaysLabelName : ''} Engagement aspect" />
                                <Tooltip target="targeted-indicator-early-days" placement="bottom">Targeted on the {todaysConfig ? todaysConfig.earlyDaysLabelName : ''} Engagement aspect</Tooltip>
                            {/if}
                            {todaysConfig.earlyDaysLabelName}
                            <Tooltip target="early-days-widget-header" placement="bottom">{todaysConfig.earlyDaysLabelName} Engagement</Tooltip>
                            {#if earlyDaysRecord.indicatorTrend == 'U'}
                                <img id="trend-indicator-early-days-increase" src="/assets/arrow/arrow-up-success.svg" class="widget-trend-arrow" alt="Overall engagement has increased compared to the previous day" />
                                <Tooltip target="trend-indicator-early-days-increase" placement="bottom">Overall engagement has increased compared to the previous day</Tooltip>
                            {/if}
                        </span>
                    
                        <div class="widget-content">
                            <div class="list-widget">
                                <div class="list-widget-body" class:compact={displayCompact}>

                                    <EarlyDaysElement display={todaysConfig.earlyDaysVisit} count={earlyDaysRecord.countVisit} 
                                        label={todaysConfig.isolationVisitLabel} activityName={"Visits"} activityNamePast={"Visited"}
                                        {displayCompact} {displayComfortable} />

                                    <EarlyDaysElement display={todaysConfig.earlyDaysWork} count={earlyDaysRecord.countWork} 
                                        label={todaysConfig.isolationWorkLabel} activityName={"Attendances"} activityNamePast={"Attended"}
                                        {displayCompact} {displayComfortable} />

                                    <EarlyDaysElement display={todaysConfig.earlyDaysPhone} count={earlyDaysRecord.countPhone} 
                                        label={todaysConfig.isolationPhoneLabel} activityName={"Top Ups"} activityNamePast={"Topped Up"}
                                        {displayCompact} {displayComfortable} />

                                    <EarlyDaysElement display={todaysConfig.earlyDaysMeal} count={earlyDaysRecord.countMeal} 
                                        label={todaysConfig.isolationMealLabel} activityName={"Selections"} activityNamePast={"Selected"}
                                        {displayCompact} {displayComfortable} />

                                    <EarlyDaysElement display={todaysConfig.earlyDaysCanteen} count={earlyDaysRecord.countCanteen} 
                                        label={todaysConfig.isolationCanteenLabel} activityName={"Purchases"} activityNamePast={"Purchased"}
                                        {displayCompact} {displayComfortable} />

                                    <EarlyDaysElement display={todaysConfig.earlyDaysGym} count={earlyDaysRecord.countGym} 
                                        label={todaysConfig.isolationGymLabel} activityName={"Attendances"} activityNamePast={"Attended"}
                                        {displayCompact} {displayComfortable} />

                                    <EarlyDaysElement display={todaysConfig.earlyDaysPa} count={earlyDaysRecord.countPa} 
                                        label={todaysConfig.isolationPaLabel} activityName={"Attendances"} activityNamePast={"Attended"}
                                        {displayCompact} {displayComfortable} />
                                </div>

                                {#if earlyDaysRecord}
                                    {#if earlyDaysRecord.dateLastEngagement}
                                        <span id="engaged-date" class="list-widget-footer">
                                            Engaged {dateDescriptionStringAddExtraDescriptor(earlyDaysRecord.labelLastEngagement, true)}
                                            <Tooltip target="engaged-date" placement="bottom">{formatDate(earlyDaysRecord.dateLastEngagement)}</Tooltip>
                                        </span>                    
                                    {:else}
                                        <span class="list-widget-footer">
                                            No Engagement
                                        </span>
                                    {/if}
                                {/if}
                            </div>
                        </div>
                    </div>
                </div>
            </button>
        {:else}
            <div class="card" class:selected={selectedInmateAspect === todaysConfig.earlyDaysLabelName}>
                <div class="card-body">
                    <div class="widget-container">  
                        <div class="widget-spinner">
                            <Spinner size="100" speed="750" color="#3d5980" thickness="3" gap="15" />
                        </div>
                    </div>
                </div>
            </div>
        {/if}
    </div>
{/if}